import React from 'react';
import { object } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as fuelSavingsActions from '../../../actions/fuelSavingsActions';
import FuelSavingsForm from './FuelSavingsForm';

class ReduxExamplePage extends React.Component {
  static propTypes = {
    actions: object.isRequired,
    fuelSavings: object.isRequired
  };

  save = () => {
    this.props.actions.saveFuelSavings(this.props.fuelSavings);
  };

  onChange = e => {
    this.props.actions.calculateFuelSavings(
      this.props.fuelSavings,
      e.target.name,
      e.target.value
    );
  };

  render() {
    const { fuelSavings } = this.props;

    return (
      <div>
        <FuelSavingsForm
          fuelSavings={fuelSavings}
          onSaveClick={this.save}
          onChange={this.onChange}
        />
      </div>
    );
  }
}

// Tell Redux exactly what state slice we want from the global state
// Note that state.fuelSavingsAppState below is the name of
// the reducer function in /reducers/fuelSavings.js
function mapStateToProps(state) {
  return {
    fuelSavings: state.fuelSavings,
    loading: state.ajaxCallsInProgress > 0
  };
}

function mapDispatchToProps(dispatch) {
  return {
    // bindActionCreators will wrap all actions in fuelSavingsActions
    // in a dispatch call so they're all available to the component
    // above on this.props.fuelSavingsActions.
    // See the Customer's App for an example of an alternative approach.
    actions: bindActionCreators(fuelSavingsActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReduxExamplePage);



// WEBPACK FOOTER //
// ./src/components/pages/ReduxExamplePage/ReduxExamplePage.js